export default {
  title: 'Магазин за Събитието',
  productPage: 'Страница на продукта',
  qty: 'К-во',
  button: {
    edit: 'Промени',
    add: 'Добави в Кошницата',
  },
};
